import "./ModalBase.css";

import React from "react";

interface ModalProps {
  header: string | React.ReactNode;
  body: string | React.ReactNode;
  footer: string | React.ReactNode;
}
export default function ModalBase(props: ModalProps) {
  return (
    <div className="loa-modal">
      <div className="loa-modal-header">{props.header}</div>
      <div className="loa-modal-content">{props.body}</div>
      <div className="loa-modal-footer">{props.footer}</div>
    </div>
  );
}
